import { render, staticRenderFns } from "./CommonEditorComponent.vue?vue&type=template&id=5bcd946b"
import script from "./CommonEditorComponent.vue?vue&type=script&lang=js"
export * from "./CommonEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports